import { Controller } from "@hotwired/stimulus"

// Кнопки +/- рядом с number-инпутом (приёмка доставки, корзина).
export default class extends Controller {
  static targets = ["input"]

  increment() {
    this.step(this.stepValue())
  }

  decrement() {
    this.step(-this.stepValue())
  }

  step(delta) {
    const input = this.inputTarget
    const current = parseInt(input.value, 10) || 0
    const min = input.min !== "" ? parseInt(input.min, 10) : 0
    const max = input.max !== "" ? parseInt(input.max, 10) : Infinity
    const next = Math.min(max, Math.max(min, current + delta))

    input.value = next
    input.dispatchEvent(new Event("input", { bubbles: true }))
    input.dispatchEvent(new Event("change", { bubbles: true }))
  }

  stepValue() {
    const step = parseInt(this.inputTarget.step, 10)
    return Number.isFinite(step) && step > 0 ? step : 1
  }
}
